import React from 'react';
import './Home.css';

import { Button } from '../../components';

const Home = () => {
	return (
		<main className="Home">
			<div className="Home__Container">
				<div className="Home__Subtitle TextShadow">
					AUSTRALIAN WILDLIFE
				</div>
				<div className="Home__Title TextShadow">FINE ART DRAWINGS</div>
				<div className="Home__Subtitle TextShadow"></div>
				<div className="Home__Title TextShadow"></div>

				<div className="Home__ButtonContainer">
					<Button
						link="/greetingcards"
						label="VIEW PRODUCTS"
					></Button>
				</div>
			</div>
		</main>
	);
};

export default Home;
